import React from "react";
import PropTypes from "prop-types";
import { I18n } from "@aws-amplify/core";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";

import { fetchGet } from "../../../api/fetch";
import { formatDate } from "../../../utils/date";
import FocusPhoto from "./FocusPhoto";

const Metadata = props => {
  const { focusElement } = props;
  const [metadata, setMetadata] = React.useState();

  React.useEffect(() => {
    getPhotoMetadata(focusElement.url);
  }, [focusElement]);

  const getPhotoMetadata = async img => {
    try {
      let fileName = img;
      if (fileName.includes("http")) {
        let index = fileName.indexOf("/api/images");
        fileName = fileName.substring(index + 12, fileName.length);
      }
      let metadata = await fetchGet(`images/${fileName}/metadata`);
      setMetadata(metadata);
    } catch (e) {
      console.log(e);
    }
  };

  const renderMetadataInfo = (title, value) => {
    return (
      <Grid item style={{ marginBottom: "15px" }}>
        <span className="text-87 bold-500">{title + ": "}</span>
        <span className="text-54">{value}</span>
      </Grid>
    );
  };

  return (
    <Grid item xs style={{ margin: "10px" }}>
      <Grid container style={{ height: "100%" }}>
        <Grid item style={{ width: "350px" }}>
          <Grid container direction="column">
            <FocusPhoto focusElement={focusElement} />
            <Grid
              item
              className="text-87 text-center"
              style={{ margin: "15px" }}
            >
              {focusElement.text ? focusElement.text : ""}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs style={{ padding: "20px 20px 20px 40px" }}>
          <Grid container direction="column" style={{ height: "100%" }}>
            {!metadata ? (
              <Grid item className="text-center" style={{ paddingTop: "30px" }}>
                <CircularProgress size={15} />
              </Grid>
            ) : (
              <>
                {renderMetadataInfo(I18n.get("site_fileName"), metadata.name)}
                {renderMetadataInfo(
                  I18n.get("site_fileSize"),
                  `${metadata.image.size} bytes`
                )}
                {renderMetadataInfo(
                  I18n.get("site_fileType"),
                  metadata.image.format
                )}
                {renderMetadataInfo(
                  I18n.get("site_lastModified"),
                  formatDate(metadata.s3.LastModified)
                )}
                {renderMetadataInfo(
                  I18n.get("site_dimensions"),
                  `${metadata.image.width} x ${metadata.image.height}`
                )}
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

Metadata.propTypes = {
  focusElement: PropTypes.object.isRequired
};

export default Metadata;
